import { useState } from 'react';
import { Form, Button, Radio, Row, Col } from 'antd';
import { InputText } from 'components/Inputs';
import InfoButton from 'components/InfoButton';
import styles from './AgendarCita.module.less';
import { formatDUI, I18nt, numbersOnly } from 'utils';
import validations from 'utils/validations/AgendarCita';
import { AgendarCitaFormParams, LangText } from 'utils/interfaces';
import { useAgendarCita } from '../AgendarCitaContext';
import BannerWithImage from 'components/BannerWithImage';

export default function FormView() {
  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState(true);
  const [duiLabel, setDuiLabel] = useState<LangText>('numero_de_dui');
  const { onFormSubmit, isFormLoading } = useAgendarCita();

  const onValuesChange = (
    changedValues: AgendarCitaFormParams,
    allValues: AgendarCitaFormParams
  ) => {
    if (changedValues.afiliado) {
      allValues.afiliado = numbersOnly(changedValues.afiliado).slice(0, 10);
    }
    if (changedValues.dui) {
      allValues.dui = formatDUI(changedValues.dui).slice(0, 10);
    }
    if (changedValues.mayor) {
      setDuiLabel(
        parseInt(changedValues.mayor)
          ? 'numero_de_dui'
          : 'numero_dui_del_cotizante'
      );
    }

    form.setFieldsValue(allValues);

    const values = form.getFieldsValue();
    if (
      values.afiliado &&
      values.dui &&
      values.mayor &&
      values.afiliado.length > 0 &&
      values.afiliado.length <= 10 &&
      values.dui.length === 10
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const onFinish = (data: AgendarCitaFormParams) => {
    onFormSubmit(data, () => {
      form.resetFields();
      setDisabled(true);
    });
  };

  const options = [
    { label: I18nt('si'), value: '1' },
    { label: I18nt('no'), value: '0' },
  ];

  return (
    <section className={styles.medAppointmentForm}>
      <BannerWithImage className={styles.headerContainer}>
        <Row justify='center'>
          <Col xs={24} sm={20} lg={10} xl={8} xxl={6}>
            <div className={styles.medFormBox}>
              <div className={styles.headerContainer}>
                <h4 className='pr-8 pl-8'>
                  {I18nt('calendarizacion_de_citas')}
                </h4>
                <p className='pr-8 pl-8'>
                  {I18nt('ingresa_los_siguientes_datos_para_consultar')}
                </p>
              </div>

              <Form
                form={form}
                layout='vertical'
                onFinish={onFinish}
                validateTrigger='onBlur'
                onValuesChange={onValuesChange}
                className={styles.formItem}
              >
                <div className={styles.radioWrapper}>
                  <Form.Item
                    name='mayor'
                    rules={validations.mayor}
                    label={I18nt('eres_mayor_de_edad')}
                  >
                    <Radio.Group
                      options={options}
                      optionType='button'
                      buttonStyle='solid'
                    />
                  </Form.Item>
                </div>
                <InputText
                  name='dui'
                  inputMode='numeric'
                  label={duiLabel}
                  rules={validations.dui}
                  placeholder='placeholder_dui'
                />
                <InfoButton image='carnet' />
                <InputText
                  name='afiliado'
                  inputMode='numeric'
                  label='numero_de_afiliado'
                  placeholder='placeholder_num_afiliado'
                  rules={validations.afiliado}
                />
                <Form.Item className='mt-16'>
                  <Button
                    block
                    type='primary'
                    htmlType='submit'
                    disabled={disabled}
                    loading={isFormLoading}
                  >
                    {I18nt('siguiente')}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </BannerWithImage>
    </section>
  );
}
